import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { Button } from "react-bootstrap";

//Components
import CustomBody from "../../CustomBody/index";

//Assets
import PickupAddress from "../../../../../images/pickup-address.png";

//Interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  alias, full_name, phone_number, address, country, province, city, suburb, postal_code,
  onBack,
  seletAddress,
  continueAction
}) => {
  return (
    <CustomBody withBack backAction={onBack}>
      <div className="pickup-address-body">
        <KickImage className="pickup-address-img" src={PickupAddress} alt="pickup address" />
        <p className="title">Set Pick-up Address</p>
        <div className="address-wrapper">
          <p className="place">{alias} - {full_name}</p>
          <p className="address">{address}, {suburb}, <span /> {city}, {province}, {postal_code}, {country}</p>
          <p className="phone-number">{phone_number}</p>
          <p className="change" onClick={seletAddress}>Change</p>
        </div>
        <Button className={`confirm`} onClick={continueAction}><span>Continue</span></Button>
      </div>
    </CustomBody>
  )
}

export default Component;